import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const CenterDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #09ac8d;
`;

interface LoadingCompProp {
  isLoading: boolean;
  children: any;
  loadingText?: any;
}

function LoadingComp(props: LoadingCompProp) {
  const { isLoading, loadingText } = props;
  if (isLoading) {
    return (
      <CenterDiv>
        <Spin />
        {loadingText}
      </CenterDiv>
    );
  } else {
    return props.children;
  }
}

export default LoadingComp;
